import React, { useRef, useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import avatarVideo from "../../assets/avatares/avatar-santiago-scn3.webm";
import avatarVideoMp4 from "../../assets/avatares/avatar-santiago-scn3.mp4";
import closeCross from "../../assets/close.svg";
import ScenarioBar from "../../components/ScenarioBar";
import NextButton from "../../components/NextButton";

import { useVideoWithSound } from "../../hooks/useVideoWithSound";
import "./Scenario3.css";

function MagnifyIcon({ size = 20 }) {
	return (
		<svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
			<circle cx="10.5" cy="10.5" r="6.5" fill="none" stroke="currentColor" strokeWidth="2" />
			<path
				d="M15.2 15.2 21 21"
				fill="none"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
			/>
		</svg>
	);
}

function Scenario3Intro({ intl }) {
	const navigate = useNavigate();
	const location = useLocation();

	const { videoRef } = useVideoWithSound({ 
		autoPlay: true, 
		volume: 0.8
	});

	const [lightbox, setLightbox] = useState(null);

	const activeScenario = getScenarioNumByPath(location.pathname);

	useEffect(() => {
		if (!lightbox) return;
		const onKey = (e) => {
			if (e.key === "Escape") setLightbox(null);
		};
		window.addEventListener("keydown", onKey);
		const prevOverflow = document.body.style.overflow;
		document.body.style.overflow = "hidden";
		return () => {
			window.removeEventListener("keydown", onKey);
			document.body.style.overflow = prevOverflow;
		};
	}, [lightbox]);

	return (
		<div className="h-100">
			<div className="container-fluid position-relative h-100">
				<div className="row h-100 d-flex align-items-center">
					<div className="col-md-4 d-flex flex-column justify-content-end h-100 px-4 pb-4">
						<video
							ref={videoRef}
							className="mb-4 pb-5"
							autoPlay
							playsInline
							preload="auto"
							muted
						>
							<source src={avatarVideoMp4}  type="video/mp4" />
							<source src={avatarVideo} type="video/webm" />
						</video>
					</div>

					{/* Columna derecha: espacio visual */}
					<div className="col-md-8 d-flex flex-column justify-content-center pt-4 align-items-end bg-blur-violet h-100 px-5">
						<div className="row recuadro-white recuadro-border-violet txtTexto1 mb-1 w-100 text-center">
							<div className="col-md-12">
								<p className="txtTexto1 black mb-4">
									Mi médico de Atención Primaria me solicitó una radiografía de rodilla y una análitica completa.
								</p>
							</div>
						</div>
						<div className="mt-1 d-flex align-items-center justify-content-end w-100">
						{/* Botón siguiente */}
						<NextButton
							navigateTo={ROUTES.SCENARIO3_CONTEXT1}
							activeScenario={activeScenario}
							color="violet"
							textColor="white"
						/>
						</div>
					</div>
				</div>
			</div>
			<ScenarioBar activeScenario={activeScenario} />
		</div>
	);
}

export default injectIntl(Scenario3Intro);
